(function($) {

	const krachtenGebundeld = {};

	krachtenGebundeld.accordion = () => {

		const accordionButtons = document.querySelectorAll('.accordion__button');
		const accordionSections = document.querySelectorAll('.accordion__section');

		accordionSections.forEach(section =>  {
			section.setAttribute('aria-hidden', true)
			section.classList.remove('open')
		})

		accordionButtons.forEach(button => {
			button.setAttribute('aria-expanded', false);

			const expanded = button.getAttribute('aria-expanded');

			const number = button.getAttribute('id').split('-').pop();
			const associatedSection = document.getElementById(`accordion-section-${number}`)

			button.addEventListener('click', () => {

				button.classList.toggle('expanded');
				associatedSection.classList.toggle('open');
				if (button.classList.contains('expanded')) {
				button.setAttribute('aria-expanded', true);
				associatedSection.setAttribute('aria-hidden', false);
				} else {
				button.setAttribute('aria-expanded', false);
				associatedSection.setAttribute('aria-hidden', true);
				}
			})
		})
	}

	krachtenGebundeld.traject = () => {
		const trajects = document.querySelectorAll('#trajectGroup');
		trajects.forEach((traject) => {
			const trajectButtons = traject.querySelectorAll('.traject__button');
			const trajectSections = traject.querySelectorAll('.traject__section');
	
			trajectSections.forEach(section =>  {
				section.setAttribute('aria-hidden', true)
				section.classList.remove('open')
			})
	
			trajectButtons.forEach(button => {
				button.setAttribute('aria-expanded', false);
	
				const expanded = button.getAttribute('aria-expanded');
	
				const number = button.getAttribute('id').split('-').pop();
				const associatedSection = traject.querySelector(`#traject-section-${number}`);
	
				button.addEventListener('click', () => {
					button.classList.toggle('expanded');
					associatedSection.classList.toggle('open');
					if (button.classList.contains('expanded')) {
						button.setAttribute('aria-expanded', true);
						associatedSection.setAttribute('aria-hidden', false);
					} else {
						button.setAttribute('aria-expanded', false);
						associatedSection.setAttribute('aria-hidden', true);
					}
				});
			});
		});
	};

	krachtenGebundeld.init = function() {
		krachtenGebundeld.accordion();
		krachtenGebundeld.traject();
	}

	krachtenGebundeld.init();



})(jQuery);
